import { App } from "vue";
import { ISystem } from "./ISystem";
import { VueSystem } from "./VueSystem";

const sys = new VueSystem();
export default sys as ISystem<App<Element>>;